// extracted by mini-css-extract-plugin
module.exports = {"ButtonRound":"ButtonRound_ButtonRound__oTeqt","ButtonRound__Link":"ButtonRound_ButtonRound__Link__ctD09","ButtonRound--Active":"ButtonRound_ButtonRound--Active__oACUa"};